<template>
  <!--  @click="handleClickEvent"-->
  <div
    v-if="isShowDownloadComponent"
    :class="getCss('footer-download')"
    :style="{
      display: this.styles.base.display,
      zIndex: this.styles.base['z-index'] || 99,
      ...footerDownloadContainerStyle,
    }"
    @click="handleClickEvent"
  >
    <!--  begin   显示合规 -->
    <template v-if="isOpenCopyRight && !!fourElementInfo.gameName">
      <c-copyright
        :configuration-data="{
          gid: configurationData.gid,
        }"
        :initDataFromProp="true"
        :fourElementInfo="fourElementInfo"
        :events="events"
      />
    </template>
    <!--  end   显示合规 -->

    <!--   begin    弹框绑定手机-->
    <CTgclubGameOrderBindPhonePop
      :configurationData="configurationData"
      v-model="hasAccessBindPhone"
      v-bind="$props"
      :subscriptionData="subscriptionData"
      @closeBindOrderPhone="closeBindOrderPhoneFunc"
    />
    <!--  左侧额外的跳转按钮    -->
    <button v-if="extraJumpOpen" :class="getCss('extra-jump-btn')" :style="extraBtn" @click="gotoLink"></button>

    <!--       android|ios 单纯预约模式-->
    <template v-if="isAccessBook === true && !configurationData.openBookAndPreDownLoad">
      <c-button
        ref="button"
        :style="computedStyle"
        :class="[extraJumpOpen ? getCss('extra-right-btn') : getCss('normal-btn')]"
        v-bind="$props"/>
    </template>
    <!--  ios 单纯预约模式且android 开启预下载    -->
    <template v-if="isAccessIOsBookAndPreDownLoad">
      <c-button
        ref="iosBookButtonAndPreDownLoad"
        :style="iosBookInAndroidOpenPreDownloadComputedStyle"
        :class="[extraJumpOpen ? getCss('extra-right-btn') : getCss('normal-btn')]"
        v-bind="$props"
      />
    </template>

    <!--    android  预下载+预约游戏模式-->
    <template v-if="isAccessAndroidBookAndPreDownLoad === true && isShowPreDownLoadProcess === false">
      <c-button
        ref="androidBookButtonAndPreDownLoad"
        :style="preDownLoadComputedStyle"
        :class="[extraJumpOpen ? getCss('extra-right-btn') : getCss('normal-btn')]"
        v-bind="$props"
      />
    </template>

    <!-- 预下载进度    -->
    <div
      v-if="isAccessAndroidBookAndPreDownLoad === true && isShowPreDownLoadProcess === true"
      :class="[extraJumpOpen ? getCss('actionBtn-right-btn') : 'actModules_action_area']"
    >
      <div class="actModules_actionBtn">
        <div class="c-access-download-process-bar" :style="progressStyle"/>
        <p class="actModules_actionBtn_text">
          <span class="actModules_actionBtn_text_percentage">{{ downloadProgressText }}</span>
          <span>%</span>
          <span v-if="totalCount > 1">({{ downLoadCount }}/{{ totalCount }})</span>
        </p>
      </div>
      <p class="actModules_actionBtnTips">{{ configurationData.onPreDownLoadMsg }}</p>
      <div class="actModules_ios_full_screen_bottom_bar" v-if="isIosFullScreenExtra"></div>
    </div>

    <!-- 云游戏    -->
    <div v-if="isAccessCloudGame && !isAccessBook && !isIOS"
         :class="[extraJumpOpen ? getCss('actionBtn-right-btn') : 'actModules_action_area']"
    >
      <div class="actModules_actionBtn_cloud_button_area">
        <div v-show="unDownloadStatus" @click="clickDownLoad" class="actModules_actionBtn_cloud">
          <p class="actModules_actionBtn_cloud_text">下载游戏</p>
        </div>

        <div @click="clickDownLoad" v-show="showProcessDownloading" class="actModules_actionBtn_cloud">
          <div class="c-access-download-process-bar-cloud" :style="progressStyle"/>
          <p class="actModules_actionBtn_cloud_text">
            <span class="actModules_actionBtn_text_percentage">{{ downloadProgressText }}</span>
            <span>%</span>
          </p>
        </div>

        <div v-show="showProcessDownloadPause" @click="clickDownLoad" class="actModules_actionBtn_cloud">
          <div class="c-access-download-process-bar-cloud" :style="progressStyle"/>
          <p class="actModules_actionBtn_cloud_text">继续</p>
        </div>
        <div v-show="startGameStatus" @click="clickDownLoad" class="actModules_actionBtn_cloud">
          <p class="actModules_actionBtn_cloud_text">启动游戏</p>
        </div>
        <div v-show="readyInstallGameStatus" @click="clickDownLoad" class="actModules_actionBtn_cloud">
          <p class="actModules_actionBtn_cloud_text">点击安装</p>
        </div>

        <div class="actModules_actionBtn_cloud" style="background: #d7b386" @click="goToCloudGame()">
          <p class="actModules_actionBtn_cloud_text" style="color: #ffffff">云游戏</p>
        </div>
      </div>
      <p class="actModules_actionBtnTips">{{footerTips}}</p>
      <div class="actModules_ios_full_screen_bottom_bar" v-if="isIosFullScreenExtra"></div>
    </div>

    <!-- 没有云游戏    -->
    <div
      v-if="(!isAccessCloudGame || isIOS) && !isAccessBook && !downloadBtnImage"
      :class="[extraJumpOpen ? getCss('actionBtn-right-btn') : 'actModules_action_area']"
      @click="clickDownLoad"
    >
      <div v-show="unDownloadStatus" class="actModules_actionBtn">
        <p class="actModules_actionBtn_text">立即下载</p>
      </div>
      <div v-show="startGameStatus" class="actModules_actionBtn">
        <p class="actModules_actionBtn_text">启动游戏</p>
      </div>

      <div v-show="readyInstallGameStatus" class="actModules_actionBtn">
        <p class="actModules_actionBtn_text">腾讯认证正版 点击安装</p>
      </div>
      <div v-show="showProcessDownloading" class="actModules_actionBtn">
        <div class="c-access-download-process-bar" :style="progressStyle"/>
        <p class="actModules_actionBtn_text">
          <span class="actModules_actionBtn_text_percentage">{{ downloadProgressText }}</span>
          <span>%</span>
        </p>
      </div>

      <div v-show="showProcessDownloadPause" class="actModules_actionBtn">
        <div class="c-access-download-process-bar" :style="progressStyle"/>
        <p class="actModules_actionBtn_text">继续</p>
      </div>
      <p class="actModules_actionBtnTips">{{footerTips}}</p>
      <div class="actModules_ios_full_screen_bottom_bar" v-if="isIosFullScreenExtra"></div>
    </div>

    <!--   可以自定义下载背景-->
    <div
      v-if="(!isAccessCloudGame || isIOS) && !isAccessBook && downloadBtnImage"
      :class="[extraJumpOpen ? getCss('actionBtn-right-btn') : ['actModules_action_area',getCss('full-height')]]"
      :style="downloadBtnStyle"
      @click="clickDownLoad"
    >
      <div v-show="unDownloadStatus" class="actModules_actionBtn" :style="actionBtnStyle">
        <p :class="['actModules_actionBtn_text',getCss('full-width')]">立即下载</p>
      </div>
      <div v-show="startGameStatus" class="actModules_actionBtn" :style="actionBtnStyle">
        <p :class="['actModules_actionBtn_text',getCss('full-width')]">启动游戏</p>
      </div>

      <div v-show="readyInstallGameStatus" class="actModules_actionBtn" :style="actionBtnStyle">
        <p :class="['actModules_actionBtn_text',getCss('full-width')]">腾讯认证正版 点击安装</p>
      </div>
      <div v-show="showProcessDownloading" class="actModules_actionBtn" :style="actionBtnStyle">
        <div class="c-access-download-process-bar"/>
        <p :class="['actModules_actionBtn_text',getCss('full-width')]">
          <span class="actModules_actionBtn_text_percentage">{{ downloadProgressText }}</span>
          <span>%</span>
        </p>
      </div>

      <div v-show="showProcessDownloadPause" class="actModules_actionBtn" :style="actionBtnStyle">
        <div class="c-access-download-process-bar"/>
        <p :class="['actModules_actionBtn_text',getCss('full-width')]">继续</p>
      </div>
      <p class="actModules_actionBtnTips" :style="actionTipsStyle">{{footerTips}}</p>
      <div class="actModules_ios_full_screen_bottom_bar" v-if="isIosFullScreenExtra"></div>
    </div>
    <!-- 可以自定义下载背景    -->

    <!-- 拉起appstore 加载提示    -->
    <div
      class="_isoDownLoadTrips"
      id="_isoDownLoadTripsTarget"
      v-if="showIosCallAppStoreTips"
      style="
        display: block;
        position: fixed;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.8);
        height: 0.52rem;
        left: 50%;
        transform: translateX(-50%);
        bottom: 2rem;
        line-height: 0.52rem;
        padding: 0 0.3rem;
        border-radius: 0.1rem;
        text-align: center;
        font-size: 0.25rem;
      "
    >
      正在努力加载中
      <span
        class="_isoDownLoadTripsPoint"
        style="display: inline-block; max-width: 0.23rem; width: 0.23rem; text-align: left"
      >{{ ellipsis }}</span
      >
    </div>
    <c-base-dialog
      v-model="isShowActivate"
      :option="iosPaymentGuideOption"
      @close="isShowActivate = false"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('dialog-body')">
          <div>请激活奖励资格后再注册游戏</div>
          <div>否则可能失去领奖资格</div>
          <div :class="getCss('dialog-div')">
            <div :class="getCss('leftDivBox')">
              <div :class="getCss('leftDivBoxTop')" @click="installApp">
                <c-button ref="button" :class="getCss('dialog-btn')" v-bind="$props" :style="btnStyleSell"></c-button>
              </div>
              <div>1.点击激活按钮</div>
            </div>
            <div :class="getCss('rightDivBox')">
              <div :class="getCss('leftDivBoxTop')">
                <img src="https://act.xinyue.qq.com/act/https://act.xinyue.qq.com/act/head.png" alt=""/>
              </div>

              <div>2.激活后游戏内注册</div>
            </div>
          </div>
          <div :class="getCss('dialog-sure')" @click="closeDialog">我知道了</div>
        </div>
      </template>
    </c-base-dialog>
    <c-base-dialog
      v-model="isShowShortcut"
      :option="iosPaymentGuideOption"
      @close="isShowShortcut = false"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('dialog-body')">
          <div>预约成功~</div>
          <div>添加快捷入口到桌面</div>
          <div>游戏上线后，可点击直达</div>
          <div @click="addShortcut">
            <c-button
              ref="button"
              v-text="shortcutContent"
              :class="getCss('dialog-sure')"
              v-bind="$props"
              :style="shortcutBtnStyleSell"
            ></c-button>
          </div>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common } from '@tencent/ceiba-base-components';
import copyright from '@tencent/ceiba-act-public-copyright';
// import copyright from '../../../../act-public-components/src/components/copyright';
import HandleNoneAppClientDownload from './none-app-env.js';
import HandleSparkAppClientDownload from './spark-app.js';
import HandleXinYueAppClientDownload from './xinyue-app.js';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import CTgclubGameOrderBindPhonePop from '@tencent/ceiba-act-tgclub-game-order-bind-phone-pop';
// import CTgclubGameOrderBindPhonePop from '../tgclub-game-order-bind-phone-pop';

import { TgclubApi } from '@tencent/ceiba-tgclub-base-components';
import {
  STATUS_ON_WAITING,
  STATUS_ON_DOWNLOADING,
  STATUS_ON_UN_DOWNLOAD,
  STATUS_ON_PAUSE,
  STATUS_ON_FINISH,
  STATUS_ON_FAIL,
  STATUS_ON_CANCEL,
  STATUS_ON_INSTALL,
  UPDATE_PROCESS_TIME_AWAIT,
  TGCLUB,
  SPARK,
  BB,
  IOS_APP_JUMP_APPSTORE,
  ANDROID_APP_DOWNLOAD_APK,
  ANDROID_H5_DOWNLOAD_APK, IOS_H5_JUMP_APP_STORE,
} from './constant.js';
// 维持实例
let client = null;
const SUBSCRIBE_GAME_CHANNEL_XINYUE = 'xy'; // 预约游戏渠道心悦-xy 闪现-sx
const SUBSCRIBE_GAME_CHANNEL_SPARK = 'sx';
// 助手拉起心悦app下载
// eslint-disable-next-line @typescript-eslint/naming-convention
const DOWNLOAD_BB_CHANNEl_GAME_PACKAGE_KEY = '__download_bb_channel_game_package';
const IOS_DOWNLOAD_URL = '//itunes.apple.com/cn/app/%E5%BF%83%E6%82%A6%E4%BF%B1%E4%B9%90%E9%83%A8-%E8%85%BE%E8%AE%AF%E6%B8%B8%E6%88%8F%E7%8E%A9%E5%AE%B6%E7%A6%8F%E5%88%A9%E5%B9%B3%E5%8F%B0/id1156439976?mt=8';
const ANDROID_DOWNLOAD_URL = '//sj.qq.com/myapp/detail.htm?apkName=com.tencent.tgclub';
const DOWNLOAD_ACCESS_FAIL_CODE = 1;
const DOWNLOAD_ACCESS_SUCCESS_CODE = 2;
export default {
  name: 'CTgclubFooterDownloadNewVersion',
  components: {
    [copyright.name]: copyright,
    [button.name]: button,
    [CDialog.name]: CDialog,
    [CTgclubGameOrderBindPhonePop.name]: CTgclubGameOrderBindPhonePop,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      shortcutContent: '立即添加',
      isShowActivateDialogCount: 1,
      isShowActivate: false,
      isShowShortcut: false,
      cssPrefix: 'tgclub-footer-download-n-v-',
      downloadState: 0,
      downloadProgress: 0.0,
      downloadSize: 0,
      totalDownloadSize: 0,
      showIosCallAppStoreTips: false, // 显示拉起appstore 提示
      ellipsis: '',
      // 是否已经预约
      hasGameBook: false,
      hasAccessBindPhone: false,
      showProcessDownloadPause: false,
      showProcessDownloading: false,
      subscriptionData: {
        mobile: '', // 已经预约的手机
        isFocusOn: false, // 是否关注公众号
        switchStatus: 1, // 短信通知状态
        gid: 0,
        nickname: '',
      },
      isCheckTimeLimitDownload: 0, // 1 不能下载时间受限   2 可以下载
      listenInstallGameTimeId: 0,
      // 监听ios 端外上报
      listenIosReportTimer: 0,
      // 是否已经登录
      checkLoginSuccess: false,
      //   上报数据
      deviceReportData: {},
      // 云下载地址
      cloudGameInfo: {},
      // 合规四要素
      fourElementInfo: {},
      isAccessCloudGame: false,
      isShowDownloadComponent: true,
      // 进度条防抖动 变量
      downloadProgressText: '0.00',
      downloadBtnImage: '', // 背景图片
      isShowPreDownLoadProcess: false, // 预下载
      listenPreDownLoadProcessTimeId: null, // 监听预下载进度
      totalCount: 0, // 预下载资源包总数
      downLoadCount: 0, // 预下载的资源包个数
      isDonePreDownLoad: false, // 预下载的资源包个数,
      isInitError: false, // 如果是拉取游戏报错 允许多个点击拉取数据做初始化
    };
  },
  computed: {
    shortcutBtnStyleSell() {
      return {
        position: 'relative',
        top: '15%',
        left: '20%',
        height: '0.6rem',
        width: '2rem',
      };
    },
    btnStyleSell() {
      return {
        background: `url(${this.configurationData.btnBgImgSell}) no-repeat center top` || '',
        backgroundSize: '100% 100%',
        position: 'relative',
        top: '15%',
        left: '8%',
        height: '0.8rem',
        width: '1.5rem',
      };
    },
    // 激活领奖资格弹窗
    iosPaymentGuideOption() {
      return Object.assign({}, this.dialogConfig, {
        fotter: true,
        close: true,
        header: '温馨提示',
        cancel: false,
        confirmStyle: this.dialogConfig?.confirmStyle,
        dialogStyle: {
          color: '#282121',
        },
      });
    },
    footerDownloadContainerStyle() {
      // 预约模式
      const style = {};
      // 保证在活动页面 下载组件复测
      if (!this.$isInEditor) {
        style.zIndex = 99;
      }
      const { openBookAndPreDownLoad = false } = this.configurationData;
      if (this.isAccessBook && !openBookAndPreDownLoad) {
        // 单纯预约
        style.height = '1.62rem';
        return style;
      }
      if (this.isAccessBook && openBookAndPreDownLoad) {
        // ios的 预约+预下载
        style.height = '1.62rem';
        return style;
      }

      if (this.downloadBtnImage) {
        // ios全面屏
        /* if (this.isIosFullScreenExtra) {
          style.height = '1.62rem';
          return style;
        }*/
        style.height = '1.62rem';
        return style;
      }
      // ios全面屏
      if (this.isIosFullScreenExtra) {
        style.height = '2.3rem';
        return style;
      }
      style.height = '1.62rem';
      return style;
    },
    isIosFullScreenExtra() {
      if (this.isIOS) {
        // 解决适配部分全面屏手机底部黑条安全区域
        const list = [
          { d: 3, w: 360, h: 780 },
          { d: 3, w: 428, h: 926 },
          { d: 3, w: 390, h: 844 },
          { d: 3, w: 360, h: 780 },
          { d: 3, w: 375, h: 812 },
          { d: 2, w: 414, h: 896 },
          { d: 3, w: 414, h: 896 },
        ];
        const { screen, devicePixelRatio } = window;
        const { height, width } = screen;
        return !!list.some(item => item.d === devicePixelRatio && item.w === width && item.h === height);
      }
      return false;
    },
    isOpenCopyRight() {
      const { openCopyRight = true } = this.configurationData;
      if (this.$isInEditor) return openCopyRight;
      return openCopyRight && !this.isIOS;
    },
    // isAccessAndroidBookAndPreDownLoad 是否进入预约+预下载功能 只有安卓设备进入
    isAccessAndroidBookAndPreDownLoad() {
      if (this.isIOS) {
        return false;
      }
      const { openBookAndPreDownLoad = false } = this.configurationData;
      return this.isAccessBook && openBookAndPreDownLoad;
    },
    /**
     * 是否满足预下载时间
     * @returns {boolean}
     */
    isOpenPreDownload() {
      const { openPreDownloadStartTime = '' } = this.configurationData;
      let checkPreDownloadStart = true;
      // 当前时间 要大于预下载启动时间
      if (openPreDownloadStartTime) {
        checkPreDownloadStart = this.getTimeStamp() > this.getTimeStamp(openPreDownloadStartTime);
      }
      console.log('开启预下载时间判定 checkPreDownloadStartTime= ', checkPreDownloadStart);
      return checkPreDownloadStart;
    },
    // isAccessIOsBookAndPreDownLoad 是否进入预约+ ios预下载功能 为了 区分
    isAccessIOsBookAndPreDownLoad() {
      // ceiba画布中预览不显示
      if (this.$isInEditor) {
        return false;
      }
      if (this.isAndroid) {
        return false;
      }
      const { openBookAndPreDownLoad = false } = this.configurationData;
      return this.isAccessBook && openBookAndPreDownLoad;
    },
    // isAccess 是否进入预约模式
    isAccessBook() {
      const { openBook = false } = this.configurationData;
      if (openBook === false) return false;
      if (this.endGameBookTime && this.getTimeStamp() <= this.getTimeStamp(this.endGameBookTime)) {
        return true;
      }
      return false;
    },
    computedStyle() {
      const { bookImage, bookDoneImage } = this.configurationData;
      return {
        cursor: 'pointer',
        position: 'static',
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundImage: `url(${this.hasGameBook === false ? bookImage : bookDoneImage})`,
      };
    },
    iosBookInAndroidOpenPreDownloadComputedStyle() {
      const { bookImage, bookDoneImage } = this.configurationData;
      return {
        cursor: 'pointer',
        position: 'static',
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundImage: `url(${this.hasGameBook === false ? bookImage : bookDoneImage})`,
      };
    },
    preDownLoadComputedStyle() {
      const {
        androidBookAndPreDownLoadImage,
        androidAppBookAndPreDownLoadDoneImage,
        androidNoneAppBookAndPreDownLoadDoneImage,
        bookDoneImage,
      } = this.configurationData;
      let bgImage = androidBookAndPreDownLoadImage;
      if (this.hasGameBook === true) {
        if (!this.isOpenPreDownload) {
          bgImage = bookDoneImage;
        } else {
          if (this.isApp && this.isDonePreDownLoad === true) {
            // 是否已经下载完
            bgImage = androidAppBookAndPreDownLoadDoneImage;
            if (this.getClient().beforePreDownloadCheck()) {
              bgImage = androidNoneAppBookAndPreDownLoadDoneImage;
            }
          } else {
            bgImage = androidNoneAppBookAndPreDownLoadDoneImage;
          }
        }
      }
      return {
        height: '1.62rem',
        cursor: 'pointer',
        position: 'static',
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundImage: `url(${bgImage})`,
      };
    },
    downloadBtnStyle() {
      const { downloadBtnImage = '' } = this.configurationData;
      return {
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundImage: `url(${downloadBtnImage})`,
      };
    },
    actionBtnStyle() {
      const { actionFontColor, actionBgColor } = this.configurationData;
      return {
        // height: '0.54rem',
        width: '100%',
        color: actionFontColor,
        backgroundColor: actionBgColor,
      };
    },
    actionTipsStyle() {
      const { actionFontColor, actionBgColor } = this.configurationData;
      return {
        // height: '0.42rem',
        color: this.extraJumpOpen ? 'rgba(0, 0, 0, 0.6)' : actionFontColor,
        backgroundColor: actionBgColor,
      };
    },
    progressStyle() {
      const style = {
        width: `${this.downloadProgressText}%`,
      };
      if (this.downloadProgressText >= 100) {
        style.BorderBottomRightRadius = '0.12rem';
        style.BorderTopRightRadius = '0.12rem';
      }
      return style;
    },
    isIOS() {
      return this.$platform.isIos;
    },
    isAndroid() {
      return this.$platform.isAndroid;
    },
    // 这里不使用业务插件 是因为存在非心悦业务（via判定）使用心悦App的下载能力
    isApp() {
      return this.isXinYueApp || this.isSparkApp || this.isBBApp;
    },
    isXinYueApp() {
      return /tgclub/.test(window.navigator.userAgent);
    },
    isSparkApp() {
      return /com\.tencent\.gamecommunity/.test(window.navigator.userAgent);
    },
    isBBApp() {
      return /gamehelper/i.test(window.navigator.userAgent);
    },
    readyInstallGameStatus() {
      return this.downloadState === STATUS_ON_FINISH;
    },
    unDownloadStatus() {
      return (
        this.downloadState === STATUS_ON_UN_DOWNLOAD
        || this.isIOS
        || this.downloadState === STATUS_ON_FAIL
        || this.downloadState === STATUS_ON_CANCEL
      );
    },
    startGameStatus() {
      return this.downloadState === STATUS_ON_INSTALL;
    },
    // 默认ios下载方式
    h5IosDownLoadFrom() {
      // 1 app跳appstore
      // 2 h5跳appstore
      return this.configurationData.H5IOS || IOS_APP_JUMP_APPSTORE;
    },
    // 默认 H5下载方式
    h5AndroidDownLoadFrom() {
      // 1 app内飞鹰下载
      // 2 直接apk下载
      return this.configurationData.H5Android || ANDROID_APP_DOWNLOAD_APK;
    },
    // 开始下载时间
    startDownLoadTime() {
      return this.configurationData.startDownLoadTime || '';
    },
    noneStartDownLoadMsg() {
      return this.configurationData.noneStartDownLoadMsg || '';
    },
    endGameBookTime() {
      return this.configurationData.endGameBookTime || '';
    },
    currentAstName() {
      let astName = TGCLUB;
      if (this.$ast.currentAstName) {
        astName = this.$ast.currentAstName();
      }
      return astName;
    },
    // 预约游戏渠道
    subscribeGameChannel() {
      let astName = TGCLUB;
      if (this.$ast.currentAstName) {
        astName = this.$ast.currentAstName();
      }
      if (astName === TGCLUB) {
        return SUBSCRIBE_GAME_CHANNEL_XINYUE;
      }
      if (astName === SPARK) {
        return SUBSCRIBE_GAME_CHANNEL_SPARK;
      }
      return SUBSCRIBE_GAME_CHANNEL_XINYUE;
    },
    /**
     * channelConfig
     * @returns {*[{ast:tgclub,channelNo:xx} ]}
     */
    gameChannelConfig() {
      const { channelConfig = [] } = this.configurationData;
      return channelConfig;
    },
    /**
     * 匹配当前活动链接是否包含某个字符串，如果命中，返回下载方式和渠道号
     * @returns {null|  {
     *                     matchText: 'via=vip_30',
     *                     androidDownloadType: 2,
     *                     iosDownloadType: 2,
     *                     channelNo: '10030476',
     *                   },
     *                   }
     */
    getMatchUrlRuleConfig() {
      const { openUrlMatchDownloadLogic = false, urlRuleConfig = [] } = this.configurationData;
      if (openUrlMatchDownloadLogic === false) {
        return null;
      }
      if (!Array.isArray(urlRuleConfig) || urlRuleConfig.length === 0) {
        return null;
      }
      let rule = null;
      for (const config of urlRuleConfig) {
        const matchText = config.matchText.trim();
        if (window.location.href.includes(matchText)) {
          rule = config;
          break;
        }
      }
      console.log('【getMatchUrlRuleConfig 命中规则= 】', rule);
      return rule;
    },
    /**
     * 是否配置左侧跳转按钮
     * @returns {boolean}
     */
    extraJumpOpen() {
      const { btnJumpOpen = false, btnJumpImage = '' } = this.configurationData;
      return btnJumpOpen && btnJumpImage !== '';
    },
    // 左侧跳转按钮背景图
    extraBtn() {
      const { btnJumpImage = '' } = this.configurationData;
      if (btnJumpImage === '') {
        return {};
      }
      return {
        backgroundImage: `url(${btnJumpImage})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      };
    },
    // 自定义文案
    footerTips() {
      const { footerTips = '成功下载安装游戏可领心悦专属好礼' } = this.configurationData;
      return footerTips;
    },
  },
  watch: {
    isDonePreDownLoad: {
      async handler(res) {
        if (res === true) {
          await this.sleep(50);
          this.reportFinishPreDownload();
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.listenInstallGameTimeId > 0) {
      clearInterval(this.listenInstallGameTimeId);
    }
    this.clearListenQueryPreDownloadProcess();
  },
  mounted() {
    console.log('configurationData= tgclub download game ', this.configurationData);
    console.log(' styles tgclub download  ', this.styles);
    if (this.$isInEditor) return true;
    // 下载模式且是开启特殊渠道判断
    this.initialize();
  },
  methods: {
    async addShortcut() {
      console.log('是否开始走这里');
      const { targetComponentShortcutId = '', targetComponentActionName = 'toDesk' } = this.configurationData;
      console.log(
        targetComponentShortcutId,
        'targetComponentShortcutId',
        'targetComponentActionName',
        targetComponentActionName,
      );
      const parentRef = (node) => {
        if (!node?.$parent) {
          return {};
        }
        // eslint-disable-next-line  no-underscore-dangle
        if (
          node.$parent
          && (node.$parent?.$el?._prevClass === 'page-scroll'
            // eslint-disable-next-line no-underscore-dangle
            || node.$parent?.$el?._prevClass === 'page-content')
        ) {
          return node.$parent;
        }
        return parentRef(node.$parent);
      };
      const parentNode = parentRef(this.$refs.button);
      console.log(parentNode, 'parentNode111111');
      if (!parentNode || !parentNode.$refs) {
        console.error('--parentNode-- not found ', parentNode);
      }
      const component = parentNode?.$refs[targetComponentShortcutId]?.[0];
      console.log(component);
      if (component && targetComponentActionName) {
        component[targetComponentActionName]();
        console.warn('-- call target component and call method params is =', component, targetComponentActionName);
      }
      this.isShowShortcut = false;
    },
    async installApp() {
      console.log('是否开始走这里');
      const { targetComponentRewardId = '', targetComponentActionName = 'openDialog' } = this.configurationData;
      console.log(
        targetComponentRewardId,
        'targetComponentRewardId',
        'targetComponentActionName',
        targetComponentActionName,
      );
      const parentRef = (node) => {
        if (!node?.$parent) {
          return {};
        }
        // eslint-disable-next-line  no-underscore-dangle
        if (
          node.$parent
          && (node.$parent?.$el?._prevClass === 'page-scroll'
            // eslint-disable-next-line no-underscore-dangle
            || node.$parent?.$el?._prevClass === 'page-content')
        ) {
          return node.$parent;
        }

        return parentRef(node.$parent);
      };
      const parentNode = parentRef(this.$refs.button);
      console.log(parentNode, 'parentNode111111');
      if (!parentNode || !parentNode.$refs) {
        console.error('--parentNode-- not found ', parentNode);
      }
      const component = parentNode?.$refs[targetComponentRewardId]?.[0];
      console.log(component);
      if (component && targetComponentActionName) {
        component[targetComponentActionName]();
        console.warn('-- call target component and call method params is =', component, targetComponentActionName);
      }

      this.isShowActivate = false;
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    initialize() {
      if (this.$isInEditor) return;
      if (this.isAccessBook) {
        this.initGameBookStatus();
        this.asyncGameBookStatus();
        // 显示4要素
        if (this.isOpenCopyRight) {
          this.queryGameInfoFunc();
        }
        return;
      }
      // 下载模式
      this.downloadBtnImage = this.configurationData.downloadBtnImage || '';
      // 查询是否显示下载组件
      if (this.getClient().isShowDownloadComponent() === false) {
        this.isShowDownloadComponent = false;
      } else {
        this.initGameInfo();
      }
    },
    getClient() {
      if (client) {
        return client;
      }
      client = this.detectClient();
      return client;
    },
    detectClient() {
      console.log('-----------astName =', this.currentAstName);
      if (this.isXinYueApp) {
        return new HandleXinYueAppClientDownload();
      }
      if (this.isSparkApp) {
        return new HandleSparkAppClientDownload();
      }
      return new HandleNoneAppClientDownload();
    },
    goToCloudGame() {
      if (!this.cloudGameInfo.cloudGameH5Url) {
        return false;
      }
      this.$ast.openView({ url: this.cloudGameInfo.cloudGameH5Url });
    },
    // 如果游戏没有配置云游戏
    async queryGameInfoFunc(isPopError) {
      const { gid } = this.configurationData;
      if (gid <= 0) {
        console.warn('download not setting gid ', gid);
        return null;
      }
      let url = `https://agw.xinyue.qq.com/api/tgclub/queryGameAddress?gid=${gid}`;
      if (window.CEIBA_ENV !== 'prod') {
        url = `https://agw-p.xinyue.qq.com/api/tgclub/queryGameAddress?gid=${gid}`;
      }
      const gameChannelAst = Boolean(common.tool.getQueryParams(DOWNLOAD_BB_CHANNEl_GAME_PACKAGE_KEY)) && this.isApp
        ? BB : this.currentAstName;
      let queryChannelNo = this.getClient().getChannel(this.gameChannelConfig, gameChannelAst);
      // 是否配有特定链接使用不用的渠道号
      if (this.getMatchUrlRuleConfig !== null) {
        queryChannelNo = this.getMatchUrlRuleConfig.channelNo;
      }
      console.log('queryChannelNo = ', queryChannelNo, 'gameChannelAst =', gameChannelAst);
      if (queryChannelNo) {
        url = `${url}&channel=${queryChannelNo}`;
      }
      const response = await this.$axiosInstance.get(url);
      console.log('response queryGameAddress ', response);
      const { ret, data = {} } = response;
      const { ret: resRet } = data;
      if (ret !== 0 || resRet !== 0) {
        this.isInitError = true;
        this.$alert({ msg: '游戏即将开放下载，请稍后尝试' });
        return null;
      }
      const {
        game_name: gameName,
        version,
        carrier = '',
        developer,
        privacy_url: privacyUrl,
        permission_url: permissionUrl,
        ios_pkg_name: iosPkgName,
        ios_download_url: iosDownloadUrl,
        qq_appid: gameQQAppid,
        android_pkg_name: packagename,
        wx_appid: gameWxAppid,
        xinyue_data: xinyueData = {},
        description = '',
      } = data.GameInfos || {};
      let { android_cdn_channels: androidCdnChannels } = data.GameInfos || {};
      if (!androidCdnChannels) {
        androidCdnChannels = {};
      }
      // 获取对应包名失败
      if (isPopError === true && !androidCdnChannels[queryChannelNo]) {
        this.isInitError = true;
        this.$alert({ msg: '游戏即将开放下载，请稍后尝试' });
        return null;
      }
      this.isInitError = false;
      // 重置当前需要的渠道号
      data.GameInfos.channel_no = queryChannelNo;
      if (androidCdnChannels[queryChannelNo]?.download_url) {
        data.GameInfos.android_download_url = androidCdnChannels[queryChannelNo].download_url;
        data.GameInfos.apk_md5 = androidCdnChannels[queryChannelNo].md5;
      }
      console.log('response queryGameAddress and data.gameInfos = ', data.GameInfos);
      // ##### ios 端外染色上报的数据
      this.deviceReportData = {
        gameQQAppid,
        gameWxAppid,
        iosPkgName,
        version,
        iosDownloadUrl,
        iOSPkgName: iosPkgName,
        packagename,
        channelid: data.GameInfos.channel_no,
      };
      // ##### 上报的数据
      console.log('-----this.deviceReportData =----', this.deviceReportData);
      // ###   四要素数据
      this.fourElementInfo = {
        privacyUrl,
        permissionUrl,
        developer,
        carrier,
        version,
        gameName,
        description,
      };
      // ###   四要素数据
      console.log('-----this.fourElementInfo =----', this.fourElementInfo);
      // cloud_game_h5_url 云游戏H5地址
      // cloud_game_pc_url 云游戏PC地址
      // cloud_game_micro_url 云游戏微端地址
      // cloud_game_promote_url 云游戏微信/QQ内推广地址
      const { cloud_game_h5_url: cloudGameH5Url = '' } = xinyueData;
      // ###   云下载数据
      if (typeof cloudGameH5Url === 'string' && cloudGameH5Url.length > 0) {
        this.isAccessCloudGame = true;
      }
      this.cloudGameInfo = {
        cloudGameH5Url,
      };
      console.log('-----this.cloudGameInfo =----', this.cloudGameInfo);
      // ###   云下载数据
      return data.GameInfos;
    },
    // 根据查询是否预约
    async triggerInitGameBookAction() {
      const { gid, autoBook = false, mustAppBook = true } = this.configurationData;
      const res = await TgclubApi.queryUserSubscription(parseInt(gid, 10));
      if (res === false) {
        this.hasGameBook = false;
        // 触发自动预约
        if (autoBook) {
          //  单纯预约|设置android预下载在ios侧   在app 内自动预约
          if (mustAppBook && this.isApp && !this.isAccessAndroidBookAndPreDownLoad) {
            this.doGameBook();
          }
          // 单纯预约|设置android预下载在ios侧 H5 自动预约
          if (!mustAppBook && !this.isAccessAndroidBookAndPreDownLoad) {
            this.doGameBook();
          }
          // 设置android预下载在android侧 在app 内自动预约
          if (mustAppBook && this.isApp && this.isAccessAndroidBookAndPreDownLoad) {
            this.doAndroidGameBookWithPreDownload();
          }
          // 设置android预下载在android侧 H5 自动预约
          if (!mustAppBook && this.isAccessAndroidBookAndPreDownLoad) {
            this.doAndroidGameBookWithPreDownload();
          }
        }
        return true;
      }

      if (res === true) {
        this.hasGameBook = true;
        // android  预下载 在 app内需要查询 查询进入
        if (this.isApp && !this.isIOS && this.isAccessAndroidBookAndPreDownLoad && this.isOpenPreDownload) {
          //  检测下载进入
          const errorMsg = this.getClient().beforePreDownloadCheck();
          if (errorMsg.length > 0) {
            console.error('检测下载进入错误信息 = ', errorMsg);
            this.$alert({ msg: errorMsg });
            this.isShowPreDownLoadProcess = false;
            return;
          }
          const checkResultPreDownloadRes = await this.checkPreDownloadDone();
          if (!checkResultPreDownloadRes) {
            this.isShowPreDownLoadProcess = true;
            this.listenQueryPreDownLoadProcess();
          }
        } else {
          this.isShowPreDownLoadProcess = false;
        }
      }
    },
    async initGameBookStatus() {
      this.$onLogined(async () => {
        this.triggerInitGameBookAction();
      });
      if (this.$refs.button) {
        this.$refs.button.setClickHandler(this.doGameBook, {
          forceApp: this.configurationData.mustAppBook,
          forceLogin: true,
          forceRole: false,
        });
      }
      if (this.$refs.iosBookButtonAndPreDownLoad) {
        this.$refs.iosBookButtonAndPreDownLoad.setClickHandler(this.doGameBook, {
          forceApp: this.configurationData.mustAppBook,
          forceLogin: true,
          forceRole: false,
        });
      }
      if (this.$refs.androidBookButtonAndPreDownLoad) {
        this.$refs.androidBookButtonAndPreDownLoad.setClickHandler(this.doAndroidGameBookWithPreDownload, {
          forceApp: false,
          forceLogin: true,
          forceRole: false,
        });
      }
    },
    // 获取预约
    async doGameBook() {
      const { bookFlowId } = this.configurationData;
      if (this.hasGameBook === true) return;
      const response = await this.flowRequest({
        flowId: bookFlowId,
        params: {
          data: JSON.stringify({
            subscribe_game_channel: this.subscribeGameChannel,
          }),
        },
      });
      const { ret, msg, data = {} } = response || {};
      console.log('do book action response ', response);

      if (ret !== 0) {
        this.reportOrderFunc('0', false);
        return this.$alert({ msg });
      }
      const { ret: resRet, msg: resMsg } = data;
      if (resRet !== 0) {
        this.reportOrderFunc('0', false);
        return this.$alert({ msg: resMsg || '预约失败' });
      }
      this.hasGameBook = true;
      this.callBack();
      // switchStatus 0 打开 1 关闭
      const { mobile = '', is_focus_on: isFocusOn = false, switch_status: switchStatus = 0 } = data;
      this.subscriptionData = {
        mobile,
        isFocusOn: !!isFocusOn,
        switchStatus,
        gid: this.configurationData.gid,
        nickname: this.userInfo?.nickName ?? '',
      };

      this.hasAccessBindPhone = true;
      this.broadcastGameBookResult(true);

      return true;
    },
    // 安卓预约且触发预下载
    async doAndroidGameBookWithPreDownload() {
      console.log('access doAndroidGameBookWithPreDownload--', this.hasGameBook);
      const { mustAppBook = false } = this.configurationData;
      // 设置成不能在端外预约
      if (mustAppBook === true && !this.isApp && this.hasGameBook === false) {
        this.$ast.gotoAPP();
        return;
      }
      // android  端外预约成功需要拉起 app 触发查看预下载
      if (!this.isApp && this.hasGameBook === true) {
        this.$ast.gotoAPP();
        return;
      }
      if (this.hasGameBook === true) return;
      const { bookFlowId } = this.configurationData;

      const response = await this.flowRequest({
        flowId: bookFlowId,
      });
      const { ret, msg, data = {} } = response || {};
      console.log('do book action response ', response);

      if (ret !== 0) {
        this.reportOrderFunc('0', false);
        return this.$alert({ msg });
      }
      const { ret: resRet, msg: resMsg } = data;
      if (resRet !== 0) {
        this.reportOrderFunc('0', false);
        return this.$alert({ msg: resMsg || '预约失败' });
      }
      this.hasGameBook = true;
      if (this.isApp && !this.isIOS && this.isOpenPreDownload) {
        //  检测下载进入
        const errorMsg = this.getClient().beforePreDownloadCheck();
        console.log('beforePreDownloadCheck errorMsg =', errorMsg);
        if (errorMsg.length > 0) {
          this.$alert({ msg: errorMsg });
          this.isShowPreDownLoadProcess = false;
          return;
        }
        const checkResultPreDownloadRes = await this.checkPreDownloadDone();
        if (!checkResultPreDownloadRes) {
          this.isShowPreDownLoadProcess = true;
          this.listenQueryPreDownLoadProcess();
        }
      } else {
        this.isShowPreDownLoadProcess = false;
      }
      this.callBack();
      this.broadcastGameBookResult(true);
      return true;
    },
    async callBack() {
      const { callBackFlowId = 0, successCallBackMsg = '', showSuccessCallBackError = false } = this.configurationData;
      console.log('run  game book callback and callBackFlowId = ', callBackFlowId);
      if (callBackFlowId > 0) {
        const response = await this.flowRequest({
          flowId: callBackFlowId,
          params: {
            role: this.roleInfo,
          },
        });
        this.refreshQua(); // 刷新礼包s
        console.log('  game book callback  response = ', response);
        const { ret, msg = '', data = {} } = response;
        const { ret: resRet = 0, msg: resMsg = '' } = data;
        if (ret === 0 && resRet === 0) {
          if (successCallBackMsg) {
            this.$alert({ msg: successCallBackMsg });
            return true;
          }
        }
        if (showSuccessCallBackError === true) {
          this.$alert({ msg: msg || resMsg });
          return true;
        }
      }
    },
    asyncGameBookStatus() {
      const { gid: targetGid } = this.configurationData;
      this.$eventBus.$on('ceiba:custom:events:game:book:result', async ({ status, gid }) => {
        if (status && targetGid && gid === targetGid) {
          this.hasGameBook = true;
        }
      });
    },
    //  存在多个预约地方的时候  同步
    broadcastGameBookResult(val) {
      const { gid } = this.configurationData;
      this.$eventBus.$emit('ceiba:custom:events:game:book:result', { status: val, gid });
    },
    async accessBindPhone() {
      const { inputPhoneFlowId = 0 } = this.configurationData;
      if (inputPhoneFlowId <= 0) return;
      this.hasAccessBindPhone = true;
    },
    async initGameInfo() {
      console.log('access initGameInfo ====');
      // 下载时间
      if (this.startDownLoadTime && this.getTimeStamp() <= this.getTimeStamp(this.startDownLoadTime)) {
        console.warn('----下载时间没有开启---', this.startDownLoadTime);
        return false;
      }
      console.log('access initGameInfo $onLogined ====');
      const responseGameInfo = await this.queryGameInfoFunc(true);
      if (responseGameInfo) {
        // 将游戏包数据放入ceiba-ui 中 gameInfo
        await this.UPDATE_GAME_INFO(responseGameInfo);
        this.getClient().setGameInfo({ ...responseGameInfo, activityId: this.$actInfo?.activity_id });
        // 检查下载进度
        this.checkDownloadState();
        this.getClient?.()?.reportGameChanelDownloadViewShow?.();
        return true;
      }
      return false;
    },
    reportDownloadEvent(key, status, eventType = '') {
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventType,
          eventData: {
            packagename: this.isIOS ? this.deviceReportData.iOSPkgName : this.deviceReportData.packagename,
            game_code: this.$actInfo?.game_code ?? '',
            status,
            dversion: this.deviceReportData.version,
            gchannelversion: this.deviceReportData.channelid,
            apkchannel: this.deviceReportData.channelid,
          },
        };
        this.reportClickRaw(params);
        console.log('reportDownloadEvent download data =', params);
      }
    },
    reportGameEvent(key, status) {
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData: {
            game_code: this.$actInfo?.game_code ?? '',
            status,
          },
        };
        this.reportClickRaw(params);
        console.log('reportDownloadEvent download data =', params);
      }
    },
    closeBindOrderPhoneFunc(silentlyDownRes) {
      const { isNeedGuidance } = this.configurationData;

      console.log('silentlyDownRes book = ', !!silentlyDownRes);
      this.hasAccessBindPhone = false;
      console.log('预约成功关闭弹框走这里');
      if (isNeedGuidance) {
        this.isShowShortcut = true;
        console.log('是否开启预约后弹出添加桌面方式');
      }
      this.reportOrderFunc('1', !!silentlyDownRes);
    },
    // 预约上报
    reportOrderFunc(status, silentlyDown) {
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'order',
          eventData: { status, game_code: this.$actInfo?.game_code ?? '', silently_down: silentlyDown ? '1' : '0' },
        };
        this.reportClickRaw(params);
        console.log('reportDownloadEvent order data =', params);
      }
    },
    closeDialog() {
      this.isShowActivate = false;
    },
    async clickDownLoad() {
      if (this.$isInEditor) return;
      if (this.isAccessBook) return;
      const { checkAccessPreConditionFlowId = 0 } = this.configurationData;
      //  前置环境条件
      const beforeCheckMsg = this.getClient().beforeDownloadCheck();
      if (beforeCheckMsg) {
        this.$alert({ msg: beforeCheckMsg });
        return false;
      }
      if (
        !this.isLogin
        && (checkAccessPreConditionFlowId > 0
        || (!this.isApp && this.isIOS && (this.getMatchUrlRuleConfig?.iosDownloadType === IOS_H5_JUMP_APP_STORE))
        || (!this.isApp && this.isAndroid && (this.getMatchUrlRuleConfig?.androidDownloadType === IOS_H5_JUMP_APP_STORE
        || this.h5AndroidDownLoadFrom === ANDROID_H5_DOWNLOAD_APK)))
      ) {
        this.$alert({
          msg: '请先登录',
        });
        return;
      }
      // 判断前置下载时间
      if (
        this.startDownLoadTime
        && this.noneStartDownLoadMsg
        && this.getTimeStamp() <= this.getTimeStamp(this.startDownLoadTime)
      ) {
        this.$alert({ msg: this.noneStartDownLoadMsg });
        this.reportDownloadEvent('0');
        return false;
      }
      // ################ k判断前置下载流程
      if (checkAccessPreConditionFlowId > 0) {
        let mainMsg;
        let mainResMsg;
        if (this.isCheckTimeLimitDownload === 0) {
          const {
            ret,
            data = {},
            msg,
          } = await this.flowRequest({
            flowId: checkAccessPreConditionFlowId,
          });
          mainMsg = msg;
          const { ret: resRet = -1 } = data;
          mainResMsg = data?.msg || '';
          if (ret === 0 && resRet === 0) {
            // 没有时间限制
            this.isCheckTimeLimitDownload = DOWNLOAD_ACCESS_SUCCESS_CODE;
          } else {
            // 后台校验时间限制了下载
            this.isCheckTimeLimitDownload = DOWNLOAD_ACCESS_FAIL_CODE;
          }
        }
        // 后台流程返回报错  不需要下载
        if (this.isCheckTimeLimitDownload === DOWNLOAD_ACCESS_FAIL_CODE) {
          this.$alert({ msg: mainMsg || mainResMsg || this.noneStartDownLoadMsg || '游戏下载时间未开放' });
          return false;
        }
      }
      // ################ 判断前置下载流程
      // 开启下载后获取接口报错之后 在点击的时候会重新拉取游戏信息
      if (this.isInitError === true) {
        const initRes = await this.initGameInfo();
        if (initRes === false) {
          return false;
        }
      }
      if (!client) return;
      console.log('【app环境】this.isApp=', this.isApp);
      if (!this.isApp) {
        // 配置双端的现在下载方式
        return this.handleDownloadH5();
      }
      // 助手内，助手渠道拉起心悦App下载助手渠道包
      if (this.currentAstName === BB && this.isBBApp) {
        console.log('clickDownLoad is in gamehelper, currentAstName = ', this.currentAstName);
        this.gotoXinYueApp();
        return false;
      }
      // 处理ios 下载
      if (this.isIOS) {
        this.doDownloadInIOS();
        this.reportDownloadEvent('download', '1', 1008);
        return false;
      }
      this.doDownloadInAndroid();
      if (localStorage.getItem('isShowActivateDialogCount') === '1') {
        this.isShowActivateDialogCount = 0;
        console.log('是否等于0');
      }
      if (this.configurationData.showOrNotDialog) {
        if (this.isShowActivateDialogCount === 1) {
          this.isShowActivate = true;
          console.log('弹框只走一次');
        }
        localStorage.setItem('isShowActivateDialogCount', '1');
      }

      return true;
    },

    bytesToMB(size) {
      if (!size || size === 0) return 0;
      return (size / 1024 / 1024).toFixed(2);
    },
    updateProcessStopShakeFunc: (function () {
      // ############利用时间戳简单实现节流
      // const that = this;
      // const getTimeFunc = () => new Date().getTime();
      // let lastTime   = getTimeFunc();
      // return function (updateFunc, wait, immediate) {
      //   console.warn('updateProcessStopShakeFunc params ', wait, immediate);
      //   const currentTime = getTimeFunc();
      //   const diff  = currentTime - lastTime;
      //   console.warn(lastTime, 'lastTime  --- access updateProcess updateProcessStopShakeFunc ');
      //   console.warn(currentTime, 'currentTime  --- access updateProcess updateProcessStopShakeFunc ', 'diff', diff);
      //   if (diff >= wait) {
      //     updateFunc.apply(that);
      //     lastTime = currentTime;
      //   }
      // };
      // ############利用时间戳简单实现节流
      // ############利用定时器简单实现
      const that = this;
      let time;
      return function (updateFunc, wait, immediate) {
        // console.warn('updateProcessStopShakeFunc setTimeOut ', wait, immediate);
        if (immediate) {
          updateFunc.apply(that);
          if (time) {
            clearTimeout(time);
            time = null;
          }
        }
        if (!time) {
          time = setTimeout(() => {
            updateFunc.apply(that);
            time = null;
          }, wait);
        }
      };
      // ############利用定时器简单实现
    }()),
    updateProcess() {
      this.downloadProgressText = this.downloadProgress;
    },

    displayDownLoadStatus(ret) {
      console.log(' =ret =-------------- ', ret);
      let { totalLen = 0, receivedLen = 0 } = ret;
      const { state = 0 } = ret;
      totalLen = totalLen || 0;
      receivedLen = receivedLen || 0;
      this.downloadSize = this.bytesToMB(receivedLen);
      this.totalDownloadSize = this.bytesToMB(totalLen);
      let tempLength = totalLen > 0 ? ((receivedLen / totalLen) * 100).toFixed(2) : 0.0;
      tempLength = tempLength >= 100 ? 100 : tempLength;
      if (tempLength !== this.downloadProgress) {
        this.downloadProgress = tempLength;
      }
      console.log(' =state =-------------- ', state);
      switch (state) {
        //  没有在下载
        case STATUS_ON_UN_DOWNLOAD:
          this.showProcessDownloadPause = false;
          this.showProcessDownloading = false;
          this.downloadState = STATUS_ON_UN_DOWNLOAD;
          break;
        // 等待中
        case STATUS_ON_WAITING:
          if (!this.showProcessDownloading) {
            this.showProcessDownloadPause = false;
            this.showProcessDownloading = true;
          }
          this.downloadState = STATUS_ON_WAITING;
          break;
        // 下载中
        case STATUS_ON_DOWNLOADING:
          if (!this.showProcessDownloading) {
            this.showProcessDownloadPause = false;
            this.showProcessDownloading = true;
          }
          this.downloadState = STATUS_ON_DOWNLOADING;
          // eslint-disable-next-line no-case-declarations
          this.updateProcessStopShakeFunc(this.updateProcess, UPDATE_PROCESS_TIME_AWAIT, this.downloadProgress >= 100);
          break;
        // 暂停
        case STATUS_ON_PAUSE:
          if (!this.showProcessDownloadPause) {
            this.showProcessDownloadPause = true;
            this.showProcessDownloading = false;
          }
          this.updateProcessStopShakeFunc(this.updateProcess, UPDATE_PROCESS_TIME_AWAIT, true);
          this.downloadState = STATUS_ON_PAUSE;
          break;
        // 完成
        case STATUS_ON_FINISH:
          this.showProcessDownloadPause = false;
          this.showProcessDownloading = false;
          this.downloadState = STATUS_ON_FINISH;
          break;
        // 失败
        case STATUS_ON_FAIL:
          this.showProcessDownloadPause = false;
          this.showProcessDownloading = false;
          this.downloadState = STATUS_ON_FAIL;
          break;
        // 取消
        case STATUS_ON_CANCEL:
          this.showProcessDownloadPause = false;
          this.showProcessDownloading = false;
          this.downloadState = STATUS_ON_CANCEL;
          break;
      }

      if (state === STATUS_ON_FINISH && this.getClient()?.needReportDownloadFinish) {
        this.reportDownloadEvent('download_finish', '1');
      }
    },
    async checkDownloadState() {
      // ios 不需要 有下载状态
      if (this.isIOS) {
        this.downloadState = STATUS_ON_UN_DOWNLOAD;
        return true;
      }
      // 已近 安装
      const isInstall = await this.getClient().isAppInstalled();
      console.log('isInstall =', isInstall);
      if (isInstall === true) {
        this.downloadState = STATUS_ON_INSTALL;
        return true;
      }
      this.getClient().checkDownloadState(this.displayDownLoadStatus.bind(this));
    },
    // 安装游戏
    installGame() {
      this.getClient().installGame();
      const that = this;
      this.listenInstallGameTimeId = setInterval(() => {
        (async () => {
          const isInstall = await this.getClient().isAppInstalled();
          if (isInstall) {
            that.downloadState = STATUS_ON_INSTALL;
            clearInterval(that.listenInstallGameTimeId);
            return true;
          }
        })();
      }, 2000);
      if (this.getClient()?.needReportInstallGame) {
        this.reportGameEvent('install_game', '1');
      }
    },
    //  拉起游戏
    callGame() {
      this.getClient().callGame();
      if (this.getClient()?.needReportlaunchGame) {
        this.reportGameEvent('launch_game', '1');
      }
    },
    // 暂停下载
    pauseDownload() {
      this.downloadState = STATUS_ON_PAUSE;
      this.showProcessDownloadPause = true;
      this.showProcessDownloading = false;
      this.getClient().stopDownloadApp(this.displayDownLoadStatus.bind(this));
      if (this.getClient()?.needReportDownloadPause) {
        this.reportDownloadEvent('download_stop', '1');
      }
    },
    //  开始下载
    startDownload() {
      this.showProcessDownloadPause = false;
      this.showProcessDownloading = true;
      this.downloadState = STATUS_ON_DOWNLOADING;
      this.getClient().startDownload(this.displayDownLoadStatus.bind(this));
      this.reportDownloadEvent('download', '1', 1008);
    },
    doDownloadInAndroid() {
      const statusHandle = {
        [STATUS_ON_UN_DOWNLOAD]: this.startDownload,
        [STATUS_ON_WAITING]: this.startDownload,
        [STATUS_ON_DOWNLOADING]: this.pauseDownload,
        [STATUS_ON_PAUSE]: this.startDownload,
        [STATUS_ON_FINISH]: this.installGame,
        [STATUS_ON_FAIL]: this.startDownload,
        [STATUS_ON_CANCEL]: this.startDownload,
        [STATUS_ON_INSTALL]: this.callGame,
      };
      const targetFunc = statusHandle[this.downloadState] || this.startDownload;
      targetFunc.apply(this);
    },
    // 下载ios  拉起appstore
    doDownloadInIOS() {
      this.downloadState = STATUS_ON_UN_DOWNLOAD;
      this.showIosDownLoadTip();
      this.getClient().doDownloadInIOS();
    },
    // 下载ios 提示
    showIosDownLoadTip() {
      let num = 0;
      const that = this;
      this.showIosCallAppStoreTips = true;
      const showIosDownLoadTipsTimeId = setInterval(
        () => (function () {
          num = num + 1;
          if (num > 3) {
            num = 1;
          }
          that.ellipsis = new Array(num).fill('.')
            .join('');
        }()),
        400,
      );
      setTimeout(() => {
        clearInterval(showIosDownLoadTipsTimeId);
        this.showIosCallAppStoreTips = false;
      }, 3000);
    },
    async doSleep(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    // 处理端外下载
    async handleDownloadH5() {
      if (this.isIOS) {
        //  端外拉起appstore 因为知几没有地方拉起app
        if (this.getMatchUrlRuleConfig?.iosDownloadType === IOS_H5_JUMP_APP_STORE) {
          this.reportDownloadEvent('download', '1', 1008);
          this.reportFlush();
          return this.getClient().doDownloadInIOS();
        }
        // 其他业务强制拉起对应app
        return this.$ast.gotoAPP();
      }
      if (this.isAndroid) {
        // 如果指定特定url 并且配置了端外下载 则触发下载
        if (this.getMatchUrlRuleConfig?.androidDownloadType === ANDROID_H5_DOWNLOAD_APK) {
          this.reportDownloadEvent('download', '1', 1008);
          this.getClient().startDownload();
          return;
        }
        if (this.h5AndroidDownLoadFrom === ANDROID_H5_DOWNLOAD_APK) {
          this.reportDownloadEvent('download', '1', 1008);
          this.getClient().startDownload();
          return;
        }
        return this.$ast.gotoAPP();
      }
    },

    // 检测是否预下载完
    async checkPreDownloadDone() {
      const { preDownLoadPackageName = '' } = this.configurationData;
      if (preDownLoadPackageName) {
        this.getClient().startPreDownload(preDownLoadPackageName);
        let res = await this.getClient().getPreDownloadProcess(preDownLoadPackageName);
        console.log(
          '------检测是否预下载完 checkPreDownloadDone res-----',
          res,
          'preDownLoadPackageName =',
          preDownLoadPackageName,
        );
        res = typeof res === 'string' ? JSON.parse(res) : res;
        const { ret = -1, totalCount = 0, downLoadCount = 0, recevivedLen = 0, totalLen = 0 } = res || {};
        if (ret !== 0) {
          this.downloadProgressText = '0.00';
          this.totalCount = 0;
          this.downLoadCount = 0;
          console.error(
            '-----检测是否预下载完 checkPreDownloadDone error  res----- ',
            res,
            'preDownLoadPackageName =',
            preDownLoadPackageName,
          );
          return false;
        }
        this.totalCount = totalCount;
        this.downLoadCount = downLoadCount;
        let tempLength = totalLen > 0 ? ((recevivedLen / totalLen) * 100).toFixed(2) : 0.0;
        tempLength = tempLength > 100 ? 100 : tempLength;
        this.downloadProgressText = tempLength > 100 ? 100 : tempLength;
        this.isDonePreDownLoad = tempLength >= 100;
        console.log('-----checkPreDownloadDone final res-----', tempLength);
        return this.isDonePreDownLoad;
      }
      return false;
    },
    listenQueryPreDownLoadProcess() {
      if (!this.isApp) {
        return false;
      }
      if (this.isIOS) {
        return false;
      }
      const that = this;
      const { preDownLoadPackageName = '' } = this.configurationData;
      this.getClient().startPreDownload(preDownLoadPackageName);

      this.listenPreDownLoadProcessTimeId = setInterval(() => {
        that.queryPreDownLoadProcess();
      }, 1000);
      this.reportFunc('predownload_start', { status: '1' });
      console.log('---------- 开始预下载上报  listenQueryPreDownLoadProcess response ---------');
    },
    clearListenQueryPreDownloadProcess() {
      if (this.listenPreDownLoadProcessTimeId > 0) {
        clearInterval(this.listenPreDownLoadProcessTimeId);
      }
    },
    async queryPreDownLoadProcess() {
      const { preDownLoadPackageName = '' } = this.configurationData;
      if (preDownLoadPackageName && this.getClient()?.getPreDownloadProcess) {
        let res = await this.getClient()?.getPreDownloadProcess(preDownLoadPackageName);
        if (!res) return;
        res = typeof res === 'string' ? JSON.parse(res) : res;
        const { ret = -1, totalCount = 0, downLoadCount = 0, recevivedLen = 0, totalLen = 0 } = res || {};
        if (ret !== 0) {
          this.downloadProgressText = 0.0;
          this.totalCount = 0;
          this.downLoadCount = 0;
          this.clearListenQueryPreDownloadProcess();
          this.reportFunc('predownload_start', { status: '0' });
          // 0正常，可读取进度；1，未启动，先调用启动下载接口；-1，当前游戏无需预下载
          console.error(
            '-----获取预下载进度queryPreDownLoadProcess error  错误代码 ----- ',
            res,
            'preDownLoadPackageName =',
            preDownLoadPackageName,
          );
          return false;
        }
        this.totalCount = totalCount;
        this.downLoadCount = downLoadCount;
        let tempLength = totalLen > 0 ? ((recevivedLen / totalLen) * 100).toFixed(2) : 0.0;
        tempLength = tempLength > 100 ? 100 : tempLength;
        this.downloadProgressText = tempLength > 100 ? 100 : tempLength;
        console.log(
          '-----获取预下载进度queryPreDownLoadProcess res-----',
          res,
          'preDownLoadPackageName =',
          preDownLoadPackageName,
          'downloadProgressText =',
          this.downloadProgressText,
        );
        if (tempLength >= 100) {
          this.clearListenQueryPreDownloadProcess();
          this.isDonePreDownLoad = true;
          this.isShowPreDownLoadProcess = false;
        }
      }
    },
    reportFunc(key, eventData) {
      if (typeof this.reportClickRaw === 'function' && key) {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData,
        };
        this.reportClickRaw(params);
        console.log('reportFunc key data =', params);
      }
    },
    async reportFinishPreDownload() {
      const { reportFinishPreDownloadFlowId = 0, preDownLoadPackageName = '' } = this.configurationData;
      console.log(
        '----access reportFinishPreDownload  reportFinishPreDownloadFlowId =',
        reportFinishPreDownloadFlowId,
        '---preDownLoadPackageName =',
        preDownLoadPackageName,
      );

      if (reportFinishPreDownloadFlowId <= 0) {
        this.reportFunc('predownload_end', { packagename: preDownLoadPackageName });
        return;
      }
      const packageStatus = this.quaInfo[reportFinishPreDownloadFlowId];
      if (!packageStatus) return false;
      if (packageStatus.total > 0 && packageStatus.remain <= 0) {
        console.warn('---------- 预下载流程已完成上报  reportFinishPreDownload 无需上报  ---------');
        return false;
      }
      const response = await this.flowRequest({
        flowId: reportFinishPreDownloadFlowId,
        params: {
          role: this.roleInfo,
        },
      });
      console.log('reportFinishPreDownload response ', response);
      const { ret, data = {} } = response;
      const { ret: resRet = 0 } = data;
      if (ret === 0 && resRet === 0) {
        console.log('---------- 预下载完成上报  reportFinishPreDownload ---------');
        this.refreshQua(); // 刷新礼包
      }
      this.reportFunc('predownload_end', { packagename: preDownLoadPackageName });
    },
    getTimeStamp(time) {
      if (time) {
        // eslint-disable-next-line no-param-reassign
        time = time.replace(/-/g, '/');
        return parseInt(new Date(time).getTime() / 1000, 10);
      }
      return parseInt(new Date().getTime() / 1000, 10);
    },
    // 跳转心悦App
    gotoXinYueApp() {
      let url = window.location.href;
      const traceId = window.ceibaTraceId;
      url = common.tool.setUrlParam('trace_id', traceId, url);
      // 强制变化心悦业务
      url = common.tool.setUrlParam('via', 'vip_0', url);
      // 下载助手渠道包
      url = common.tool.setUrlParam(DOWNLOAD_BB_CHANNEl_GAME_PACKAGE_KEY, '1', url);
      // 跳转tgclub:// 最外层协议 需要加上 trace_id
      const schemaUrl = `tgclub://redirect?url=${encodeURIComponent(url)}&share=0&trace_id=${traceId}`;
      if (!this.isXinYueApp) {
        if (!this.$platform.isIos && !this.$platform.isAndroid) {
          this.alert('仅适用IOS或Android');
          return;
        }
        console.log('--------schemaUrl = ', schemaUrl);

        if (this.$platform.isIos) {
          console.log('--------ios redirect scheme--------');
          window.location.href = schemaUrl;
        } else {
          console.log('--------android redirect scheme--------');
          const iframe = document.createElement('iframe');
          iframe.setAttribute('src', schemaUrl);
          iframe.setAttribute('style', 'display:none');
          document.body.appendChild(iframe);
        }

        // 延迟2.5秒跳转到安装地址
        const that = this;
        const timer = setTimeout(() => {
          if (that.$platform.isIos) {
            window.location.href = IOS_DOWNLOAD_URL;
          } else if (that.$platform.isAndroid) {
            window.location.href = ANDROID_DOWNLOAD_URL;
          }
        }, 2500);
        // 判断是否隐藏页面,如隐藏则清除timer
        let visibilityChange = 'visibilitychange';
        if (typeof document.hidden !== 'undefined') {
          visibilityChange = 'visibilitychange';
        } else if (typeof document.mozHidden !== 'undefined') {
          visibilityChange = 'mozvisibilitychange';
        } else if (typeof document.msHidden !== 'undefined') {
          visibilityChange = 'msvisibilitychange';
        } else if (typeof document.webkitHidden !== 'undefined') {
          visibilityChange = 'webkitvisibilitychange';
        }
        document.addEventListener(
          visibilityChange,
          (event) => {
            const isHidden = that.$platform.isIos ? event.hidden : document.hidden;
            if (isHidden) {
              clearTimeout(timer);
            }
          },
          false,
        );
      }
    },
    // 左侧跳转按钮调用跳转
    gotoLink() {
      const { btnJumpLink = '', jumpInApp = false } = this.configurationData;
      if (btnJumpLink === '') {
        return;
      }
      // 如果需要在app内操作跳转，没在app,跳app
      if (jumpInApp && !this.$ast.isAPP()) {
        this.$ast.gotoAPP();
        return;
      }
      setTimeout(() => {
        let link = btnJumpLink;
        // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
        link = common.tool.passThroughUrlParam(link, ['via', 'trace_id', 'via_source']);
        this.$ast.openView({ url: link });
      }, 500);
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';

.actModules_action_area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.c-access-download-process-bar {
  position: absolute;
  height: 0.8rem;
  background: linear-gradient(270deg, rgba(255, 255, 255, 0.45) 0%, rgba(255, 255, 255, 0) 102.68%);
  z-index: 100;
  border-top-left-radius: 0.12rem;
  border-bottom-left-radius: 0.12rem;
}

.c-access-download-process-bar-cloud {
  position: absolute;
  height: 0.8rem;
  background: linear-gradient(270deg, rgba(215, 179, 134, 0.4) 0%, rgba(255, 255, 255, 0) 102.68%);
  z-index: 100;
  border-top-left-radius: 0.12rem;
  border-bottom-left-radius: 0.12rem;
}

.actModules_actionBtn {
  height: 0.8rem;
  width: 6.86rem;
  background-color: #d7b386;
  margin-top: 0.18rem;
  border-radius: 0.12rem;
  position: relative;
}

.actModules_actionBtn_text {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 500;
  font-size: 0.32rem;
  color: #ffffff;
  text-align: center;
  line-height: 0.8rem;
  height: 0.8rem;
  letter-spacing: 0.02rem;
  position: absolute;
  z-index: 200;
  width: 6.86rem;
}

.actModules_actionBtn_cloud_button_area {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  width: 6.86rem;
  margin-top: 0.18rem;
}

.actModules_actionBtn_cloud_text {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 500;
  font-size: 0.32rem;
  line-height: 0.8rem;
  height: 0.8rem;
  text-align: center;
  color: #b68950;
  letter-spacing: 0.02rem;
}

.actModules_actionBtn_cloud {
  border-radius: 0.12rem;
  width: 3.35rem;
  height: 0.8rem;
  background-color: #f5f3f0;
  position: relative;
}

.actModules_ios_full_screen_bottom_bar {
  padding-bottom: 0.68rem;
  width: 100%;
}

.actModules_actionBtnTips {
  font-size: 0.24rem;
  color: #8e8e93;
  line-height: 0.42rem;
  height: 0.42rem;
  text-align: center;
  letter-spacing: 0.06rem;
  font-family: 'PingFang SC';
  font-weight: 400;
  margin-top: 0.11rem;
  padding-bottom: 0.14rem;
}

.actModules_DownLoadPercent {
  z-index: 10;
}

.download-progress {
  color: #ffffff;
}

.actModules_actionBtn_text_percentage {
  display: inline-block;
  width: 1rem;
  white-space: nowrap;
  text-align: right;
  letter-spacing: 0.03rem;
}
</style>
